import React from "react";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CiImageOn } from "react-icons/ci";
import downloadIcon from "../../../assets/download_icon.svg"
import eyeIcon from "../../../assets/eye_icon.svg"
import replyIcon from "../../../assets/reply_icon.svg"
import resultimg from "../../../assets/result_img.png"
import userPic from "../../../assets/imgby_artist1.png"
import { Header } from "../../../components/header/Header";
import { CommentCheck } from "../../../components/comment/CommentCheck";

export const CommentContests = () => {
    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);
    const formik = useFormik({
        initialValues: {
            name: "",
            description: "",
            image1: null,
            image2: null,
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Sketch type is required"),
            description: Yup.string().required("Description is required"),
            image1: Yup.mixed().required("First image is required"),
            image2: Yup.mixed().required("Second image is required"),
        }),
        onSubmit: (values) => {
         
            alert("Form submitted successfully!");
        },
    });
    // Image Handlers
    const handleImageChange1 = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage1(URL.createObjectURL(file));
            formik.setFieldValue("image1", file);
        }
    };
    const handleImageChange2 = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage2(URL.createObjectURL(file));
            formik.setFieldValue("image2", file);
        }
    };

    const users = [
        {
            name: "Lila Carter",
            title: "Character designer",
            profilePic: userPic,
        },
    ];

    return (
        <>
            <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
                {/* Header */}
                <Header title={"Contest"} showBack={true} />
            </header>
            <div className="w-full bg-[#F7F7F7] min-h-screen">
                <div className="w-full min-h-screen max-w-[1164px] mx-auto flex flex-col items-start justify-center gap-10 lg:flex-row mt-9">
                    {/* Left Side */}
                    <div className='w-full lg:max-w-[446px] flex  flex-col '>
                        <form onSubmit={formik.handleSubmit} className="w-full flex flex-col">
                            <div className="w-full border border-border_color rounded-[14px] p-2 sm:p-4 mb-4">
                                {/* Title */}
                                <h2 className="text-start text-black text-[20px] font-bold font-grotesk ">
                                    Sketch Type
                                </h2>
                                {/* Sketch Character Field */}
                                <div className="mt-2">
                                    <input
                                        type="text"
                                        name="name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.name}
                                        className="w-full px-[14px] py-2 bg-white border text-[#201D1D] text-[12px] font-medium font-grotesk border-border_color rounded-md outline-none focus:ring-1 focus:ring-primary focus:border-primary"
                                        placeholder="Character designer"
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <p className="text-red-600 text-xs">{formik.errors.name}</p>
                                    ) : null}
                                </div>
                                {/* Uploaded Images */}
                                <h2 className="text-start text-black text-[20px] font-bold font-grotesk mt-3">
                                    Uploaded Images
                                </h2>
                                <div className="w-full flex  items-center justify-center gap-2 mt-2">
                                    {/* First Box */}
                                    <label
                                        htmlFor="picUpload1"
                                        className="relative flex-1 max-w-[200px] h-[174px] cursor-pointer"
                                    >
                                        <div className="w-full h-full bg-white rounded-xl overflow-hidden flex items-center justify-center border border-gray-200">
                                            {image1 ? (
                                                <img src={image1} alt="Preview 1" className="w-full h-full object-cover" />
                                            ) : (
                                                <CiImageOn className="text-8xl text-gray-300" />
                                            )}
                                        </div>
                                    </label>
                                    <input
                                        type="file"
                                        id="picUpload1"
                                        accept="image/*"
                                        onChange={handleImageChange1}
                                        className="hidden"
                                    />
                                    {formik.touched.image1 && formik.errors.image1 ? (
                                        <p className="text-red-600 text-xs">{formik.errors.image1}</p>
                                    ) : null}

                                    {/* Second Box */}
                                    <label
                                        htmlFor="picUpload2"
                                        className="relative flex-1 max-w-[200px] h-[174px] cursor-pointer"
                                    >
                                        <div className="w-full h-full bg-white rounded-xl overflow-hidden flex items-center justify-center border border-gray-200">
                                            {image2 ? (
                                                <img src={image2} alt="Preview 2" className="w-full h-full object-cover" />
                                            ) : (
                                                <CiImageOn className="text-8xl text-gray-300" />
                                            )}
                                        </div>
                                    </label>
                                    <input
                                        type="file"
                                        id="picUpload2"
                                        accept="image/*"
                                        onChange={handleImageChange2}
                                        className="hidden"
                                    />
                                    {formik.touched.image2 && formik.errors.image2 ? (
                                        <p className="text-red-600 text-xs">{formik.errors.image2}</p>
                                    ) : null}
                                </div>
                            </div>
                            {/* Description */}
                            <div className="w-full border border-border_color rounded-[14px] flex flex-col p-2 sm:p-4 items-center mt-4">
                                <textarea
                                    rows={7}
                                    name="description"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.description}
                                    placeholder="The additional information provided by the user for the sketch..."
                                    className="w-full max-w-[750px] resize-none p-3 rounded-xl bg-transparent focus:outline-none text-sm"
                                ></textarea>
                                {formik.touched.description && formik.errors.description ? (
                                    <p className="text-red-600 text-xs">{formik.errors.description}</p>
                                ) : null}
                            </div>
                        </form>
                        <hr className="mt-5 mb-5" />
                        <div className="flex flex-col gap-2 p-2">
                            <h2 className="font-bold font-grotesk text-sm  text-black">Artist Name</h2>
                            <div className="w-full flex">
                                <div className="flex flex-col gap-4">
                                    {users.map((user) => (
                                        <div key={user.id} className="flex items-center gap-2">
                                            {/* Profile Pic */}
                                            <div className="w-[69px] h-[69px] border-2 border-secondary rounded-full p-[1px] flex items-center justify-center">
                                                <div className=" w-[57px] h-[57px]  rounded-full overflow-hidden">
                                                    <img
                                                        src={user.profilePic}
                                                        alt="Profile"
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                            {/* User Info */}
                                            <div>
                                                <p className="text-[16px] text-black font-bold font-grotesk">
                                                    {user.name}
                                                </p>
                                                <p className="text-sm text-[#1F1F1F] font-medium font-grotesk">
                                                    {user.title}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Right Side */}
                    <div className="w-full lg:max-w-[666px] sm:min-w-[440px]  flex flex-col gap-5">
                        <div className="w-full h-[377px]  flex flex-col items-start  rounded-[14px] overflow-hidden relative">
                            <img src={resultimg} alt="" className="w-full h-full object-cover" />
                            <div className="absolute bottom-4 right-4 flex items-center gap-2">
                                <button className="bg-secondary h-9 p-[10px] rounded-lg"><img src={downloadIcon} alt="Download" /></button>
                                <button className="bg-secondary h-9 p-[10px] rounded-lg"><img src={eyeIcon} alt="Icon" /></button>
                            </div>
                        </div>
                        {/* Comments Section */}
                        <CommentCheck />
                    </div>
                </div>
            </div>
        </>
    )
}
